import { createSlice } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'

const initialState = {
    fleetFilters: {
        query: '',
        locationFilters: [],
        equipmentFilters: [],
        ownershipFilters: [],
    },
}

const fleetSlice = createSlice({
    name: 'Fleet',
    initialState,
    reducers: {
        saveFleetFilters(state, { payload }) {
            state.fleetFilters = payload
        },
        resetAllFilters(state) {
            state.fleetFilters = initialState.fleetFilters
        },
    },
})

export const { actions } = fleetSlice
export default fleetSlice.reducer

export const useFleetActions = () => {
    const dispatch = useDispatch()

    const saveFleetFilters = filters => {
        dispatch(actions.saveFleetFilters(filters))
    }

    const resetAllFilters = () => {
        dispatch(actions.resetAllFilters())
    }

    return {
        saveFleetFilters,
        resetAllFilters,
    }
}
